import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { ElementWidthClassDirective } from '@app/shared/directives/element-width-class-directive';
import { POPUP_MINIMIZED_WIDTH_SIZE } from '@app/main/main-content/floating-popup-manager/configs/floating-popup.config';
import { IFloatingPopupInstance } from '@app/main/main-content/floating-popup-manager/interfaces/floating-popup-instance';
import { FpLoggerNoiseSpreadStore } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread/fp-logger-noise-spread.store';
import { FpLoggerNoiseSpreadChartService } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/services/fp-logger-noise-spread-chart.service';
import { FloatingPopupBarChartWrapperComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-bar-chart-wrapper/floating-popup-bar-chart-wrapper.component';
import { FloatingPopupBaseErrorMessageComponent } from '@app/main/main-content/floating-popup-manager/components/floating-popup-base-error-message/floating-popup-base-error-message.component';

@Component({
  selector: 'gc-fp-logger-noise-spread-minimized',
  standalone: true,
  imports: [ElementWidthClassDirective, FloatingPopupBarChartWrapperComponent, FloatingPopupBaseErrorMessageComponent],
  templateUrl: './fp-logger-noise-spread-minimized.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'h-full',
  },
})
export class FpLoggerNoiseSpreadMinimizedComponent {
  public readonly currentTabStore = inject(FpLoggerNoiseSpreadStore);
  protected readonly translateService = inject(TranslateService);
  protected readonly chartService = inject(FpLoggerNoiseSpreadChartService);

  public popup = input<IFloatingPopupInstance>();

  public readonly POPUP_MINIMIZED_WIDTH_SIZE = POPUP_MINIMIZED_WIDTH_SIZE;

  private readonly popupMainData = toSignal(this.currentTabStore.popupMainData$, {
    initialValue: null,
  });

  private readonly data = toSignal(this.currentTabStore.data$, {
    initialValue: null,
  });

  public error = toSignal(this.currentTabStore.error$, {
    initialValue: null,
  });

  public isChartDataExist = computed(() => !!this.data()?.length);

  public readonly loggerDeployment = computed(() => this.popupMainData()?.deployment);

  public combinedChartData = computed(() => {
    const data = this.data() || [];

    const chartData = this.chartService.getMinimizedDataForChart(data);
    const chartOptions = this.chartService.generateMinimizedOptions();

    return { chartData, chartOptions };
  });
}
